// extracted by mini-css-extract-plugin
export default {"lawyerList":"style_lawyerList__2riee","lawyer":"style_lawyer__OV48K","photoCard":"style_photoCard__gjcvO","photo":"style_photo__biHVg"};